import { render, staticRenderFns } from "./AppliedDeliveryTemplatePopup.vue?vue&type=template&id=245d20b8&"
import script from "./AppliedDeliveryTemplatePopup.vue?vue&type=script&lang=ts&"
export * from "./AppliedDeliveryTemplatePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports